import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';

const Setting = () => {
  const dispatch = useDispatch();
  const [banner, setBanner] = useState<{ file?: File, preview?: string, link?: string }>({});

  const fetchSettings = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.setting.index, true).get();

    if (res.code == 200) {
      setBanner({
        preview: res.data?.find(e => e.key == 'topBanner')?.value || '',
        link: res.data?.find(e => e.key == 'topBannerLink')?.value || ''
      });
    }

    dispatch(setLoading(false));
  };

  const send = async () => {
    dispatch(setLoading(true));

    const formData = new FormData();
    banner.file && formData.append('image', banner.file);
    formData.append('link', banner.link || '');

    const res = await restApi(endpoints.setting.topBanner, true).upload(formData);

    if (res.code == 200) {
      Swal.fire({
        title: 'موفق',
        text: 'تنظیمات با موفقیت ذخیره شد',
        icon: 'success',
        confirmButtonText: 'متوجه شدم'
      });
      fetchSettings();
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const removeBanner = async () => {
    const { isConfirmed } = await Swal.fire({
      title: 'حذف بنر',
      text: 'آیا از حذف بنر بالای سایت اطمینان دارید؟',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'حذف',
      cancelButtonText: 'انصراف'
    });
    if (!isConfirmed) return;

    dispatch(setLoading(true));

    const res = await restApi(endpoints.setting.topBanner, true).delete({});

    if (res.code == 200) {
      setBanner({});
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
            ذخیره تنظیمات
          </span>
          <span>
            <h1 className="dashBoardTitle">تنظیمات عمومی</h1>
          </span>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">بنر بالای سایت</h1>
          <form className="addInfo" onSubmit={e => e.preventDefault()}>
            <small>این بنر در بالای تمام صفحات سایت، بالاتر از هدر نمایش داده میشود.</small>
            <label className="sideBarTitle" htmlFor="topBannerImage">تصویر بنر</label>
            <input className="addInput" id="topBannerImage" type="file" accept="image/*" onChange={(input: any) => {
              const file = input.target.files?.[0];
              file && setBanner(prev => ({
                ...prev,
                file: file,
                preview: URL.createObjectURL(file)
              }));
            }}/>
            {banner.preview &&
              <img src={banner.preview} alt="بنر بالای سایت" style={{ width: '100%', maxHeight: 200, objectFit: 'contain' }}/>
            }
            <label className="sideBarTitle" htmlFor="topBannerLink">لینک بنر (اختیاری)</label>
            <input className="addInput" id="topBannerLink" dir="ltr" placeholder="https://..." onChange={(input: any) => setBanner(prev => ({
              ...prev,
              link: input.target.value
            }))} value={banner.link || ''}/>
            {banner.preview && !banner.file &&
              <span className="cancelDerham clickable" onClick={removeBanner}>حذف بنر</span>
            }
          </form>
        </section>
      </main>
      </body>
    </>
  );
};
export default Setting;
